<div class="card w-100">
    <!-- ngx-datatables responsive -->
    <ngx-datatable *ngIf="tickers_data"
      #table
      class="bootstrap core-bootstrap w-100"
      [columnMode]="ColumnMode"
      [headerHeight]="40"
      [rowHeight]="'auto'"
      [footerHeight]="'auto'"
      [rows]="tickers_data"
      [scrollbarH]="true"
      [scrollbarV]="false"
      [externalPaging]="true"
      [offset]="page - 1"
      [limit]="limit"
      [count]="count"
      [selectionType]="SelectionType"
      (select)="onSelect($event)"
    >
      <ngx-datatable-column [headerClass]="'company'" [name]="type=='crypto'? 'Crypto' : 'Company'" [width]="100" prop="companyName" [sortable]="false">
        <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
          <div class="d-flex align-items-center w-100" >
            <div>
              <ng-container *ngIf="this.type == 'stock'" >
                <img
                  placement="right"
                  [ngbTooltip]="row?.companyName"
                  class="rounded-circle mr-1"
                  [src]="'assets/images/ticker-icons/'+row?.ticker.toString().toUpperCase()+'.png'"
                  class="mr-75"
                  height="32"
                  width="32"
                />
              </ng-container>
              <ng-container *ngIf="this.type == 'crypto'">
                <img
                placement="right"
                [ngbTooltip]="row?.companyName"
                class="rounded-circle mr-1"
                [src]="'assets/images/crypto-icons/'+row?.ticker.toString().toUpperCase()+'.jpg'"
                class="mr-75"
                height="32"
                width="32"
              />
              </ng-container>
            </div>
            <div class="cell-line-height w-100" placement="right" [ngbTooltip]="row?.companyName">
              <p class="font-medium-1 line-height-1 mb-0">{{ row?.ticker | uppercase }}</p>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [headerClass]="'price'" *ngIf="type == 'stock'" name="Price" prop="price" [width]="80" [sortable]="false">
        <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
          <div #btnElement>
            {{row?.price | currency: 'USD':'symbol':'1.2-2'}}
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [headerClass]="'price'" *ngIf="type == 'crypto'" name="Price" prop="price" [width]="80" [sortable]="false">
        <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
          <div #btnElement>
            {{row?.price | currency: 'USD':'symbol':'1.2-5'}}
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [headerClass]="'percentagechange'" name="% Change" prop="percentageChange" [width]="80" [sortable]="false">
        <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
          <div #btnElement>
            <span [ngClass]="{'text-success': row?.percentageChange > 0, 'text-danger': row?.percentageChange < 0}">{{row?.percentageChange | number : '1.0-2'}} <ng-container *ngIf="row?.percentageChange">%</ng-container></span>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [headerClass]="'sentiment'" name="Sentiment" prop="sentiment" [width]="100" [sortable]="false">
        <ng-template let-row="row" let-rowIndex="rowIndex" let-socialSentiment="value" ngx-datatable-cell-template>
          <ticker-value [value]="socialSentiment" [showLabel]="true" [tooltipDesc]="row?.scoreDescription?.sentimentDesc" [tooltipPlacement]="rowIndex >= 8 ? 'top' : 'bottom'"></ticker-value>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [headerClass]="'technical'" name="Technical" prop="technical" [width]="100" [sortable]="false">
        <ng-template let-row="row" let-rowIndex="rowIndex" let-socialSentiment="value" ngx-datatable-cell-template>
          <ticker-value [value]="socialSentiment" [showLabel]="true" [tooltipDesc]="row?.scoreDescription?.technicalDesc" [tooltipPlacement]="rowIndex >= 8 ? 'top' : 'bottom'"></ticker-value>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column *ngIf="this.type == 'crypto'" [headerClass]="'fundamental'" name="Fundamental" [width]="110" prop="onchainAndFundamental" [sortable]="false">
        <ng-template let-row="row" let-rowIndex="rowIndex" let-alternativeFundamental="value" ngx-datatable-cell-template>
          <ng-container *ngTemplateOutlet="fundamentalTemp; context: { value: row?.onchainAndFundamental }"></ng-container>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column *ngIf="this.type == 'crypto'" [cellClass]="'crypto'" [headerClass]="'score'" [width]="110" name="favorability" prop="favorabilityScore" [sortable]="false">
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
          <ng-container *ngTemplateOutlet="fvtTemp; context: { value: row?.favorabilityScore }"></ng-container>
        </ng-template>
      </ngx-datatable-column>

      <!-- STOCK -->
      <ngx-datatable-column *ngIf="this.type == 'stock'" [headerClass]="'fundamental'" name="Fundamental" prop="fundamental" [width]="110" [sortable]="false">
        <ng-template let-row="row" let-rowIndex="rowIndex" let-alternativeFundamental="value" ngx-datatable-cell-template>
          <ticker-value [value]="alternativeFundamental" [showLabel]="true" [tooltipDesc]="row?.scoreDescription?.fundamentalDesc" [tooltipPlacement]="rowIndex >= 8 ? 'top' : 'bottom'"></ticker-value>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column *ngIf="this.type == 'stock'" [headerClass]="'valuation'" name="Valuation" prop="valuation" [width]="100" [sortable]="false">
          <ng-template let-row="row" let-rowIndex="rowIndex" let-valuationLevel="value" ngx-datatable-cell-template>
            <ticker-value [value]="valuationLevel" [showLabel]="true" [tooltipDesc]="row?.scoreDescription?.valuationDesc" [tooltipPlacement]="rowIndex >= 8 ? 'top' : 'bottom'"></ticker-value>
          </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column *ngIf="this.type == 'stock'" [headerClass]="'macro'" name="Macro" prop="macro" [width]="115" [sortable]="false">
          <ng-template let-row="row" let-rowIndex="rowIndex" let-macroCondition="value" ngx-datatable-cell-template>
            <ticker-value [value]="macroCondition" [showLabel]="true" [tooltipDesc]="row?.scoreDescription?.macroDesc" [tooltipPlacement]="rowIndex >= 8 ? 'top' : 'bottom'"></ticker-value>
          </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column *ngIf="this.type == 'stock'" [cellClass]="'bg'" [headerClass]="'shortTermConviction'" name="Short term" prop="shortTermConviction" [width]="100" [sortable]="false">
        <ng-template let-shortTermConviction="value" ngx-datatable-cell-template>
          <ticker-value  [value]="shortTermConviction" [showLabel]="true"></ticker-value>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column *ngIf="this.type == 'stock'" [cellClass]="'bg'" [headerClass]="'longTermConviction'" name="Long term" prop="longTermConviction" [width]="100" [sortable]="false">
        <ng-template let-longTermConviction="value" ngx-datatable-cell-template>
          <ticker-value [value]="longTermConviction" [showLabel]="true"></ticker-value>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column *ngIf="this.type == 'stock'" [cellClass]="'bg'" [headerClass]="'score'" name="favorability" prop="score" [width]="120" [sortable]="false">
        <ng-template let-score="value" let-rowIndex="rowIndex" ngx-datatable-cell-template>
          <ticker-value [value]="score" [showLabel]="true" [tooltipPlacement]="rowIndex >= 8 ? 'top' : 'bottom'"></ticker-value>
        </ng-template>
      </ngx-datatable-column>
  
      <ngx-datatable-footer *ngIf="true">
        <ng-template
        ngx-datatable-footer-template
        let-rowCount="rowCount"
        let-pageSize="pageSize"
        let-selectedCount="selectedCount"
        let-curPage="curPage"
        let-offset="offset"
        let-isVisible="isVisible">
  
        <div class="page-count">
          <span>
              Showing {{(curPage * pageSize) - (pageSize - 1)}} to {{(curPage * pageSize) >= rowCount ? rowCount: (curPage * pageSize)}}
          </span>
          of {{rowCount.toLocaleString()}} entries
        </div>
      <datatable-pager
          [pagerLeftArrowIcon]="'datatable-icon-left'"
          [pagerRightArrowIcon]="'datatable-icon-right'"
          [pagerPreviousIcon]="'datatable-icon-prev'"
          [pagerNextIcon]="'datatable-icon-skip'"
          [page]="curPage"
          [size]="pageSize"
          [count]="rowCount"
          [hidden]="!((rowCount / pageSize) > 1)"
          (change)="pageChange($event)"
          >
      </datatable-pager>
      </ng-template>
      </ngx-datatable-footer>
    </ngx-datatable>
    <!--/ ngx-datatables responsive -->
  </div>
  
<!-- FOR CRYPTO FUNDAMENTAL -->
<ng-template #fundamentalTemp let-value="value">
  <div [ngSwitch]="value" class="w-full py-1 row justify-content-center align-items-center">
    <div *ngSwitchCase="'improving'" class="badge-light-success badge badge-pill px-1"><span>{{value | titlecase}}</span></div>
    <div *ngSwitchCase="'neutral'" class="badge-light-warning badge badge-pill px-1"><span>{{value | titlecase}}</span></div>
    <div *ngSwitchCase="'weakening'" class="badge-light-danger badge badge-pill px-1"><span>{{value | titlecase}}</span></div>
    <div *ngSwitchDefault class="badge badge-pill badge-light-secondary px-1"><span>{{status}}</span></div>
  </div>
</ng-template>

<!--  -->
<ng-template #fvtTemp let-value="value">
  <ng-container *ngIf="value">
    <div *ngIf="value > 70" class="badge-light-success badge badge-pill px-1">
      <i [data-feather]='"thumbs-up"'></i>
      <span class="center-value">{{value}}</span>
    </div>
    <div *ngIf="value >= 40 && value <= 70" class="badge-light-warning badge badge-pill px-1">
      <i [data-feather]='"shield"'></i>
      <span class="center-value">{{value}}</span>
    </div>
    <div *ngIf="value < 39" class="badge-light-danger badge badge-pill px-1">
      <i [data-feather]='"thumbs-down"'></i>
      <span class="center-value">{{value}}</span>
    </div>
  </ng-container>
  <ng-container *ngIf="!value">
    <div class="badge badge-pill badge-light-secondary px-1">
      <i [data-feather]='"alert-triangle"'></i>
      <span class="center-value">{{status}}</span>
    </div>
  </ng-container>
</ng-template>